import { createAction } from 'redux-actions';

import {
  LOAD_PATIENT_LIST,
  LOAD_PATIENT_LIST_SUCCESS,
  LOAD_PATIENT_LIST_ERROR,
  //load list for current manage patient
  LOAD_CURRENT_MANAGE_PATIENT_LIST,
  LOAD_CURRENT_MANAGE_PATIENT_LIST_SUCCESS,
  LOAD_CURRENT_MANAGE_PATIENT_LIST_ERROR,
  LOAD_PATIENT_DETAIL,
  LOAD_PATIENT_DETAIL_SUCCESS,
  LOAD_PATIENT_DETAIL_ERROR,
  CREATE_PATIENT,
  CREATE_PATIENT_SUCCESS,
  CREATE_PATIENT_ERROR,
  UPDATE_PATIENT,
  UPDATE_PATIENT_SUCCESS,
  UPDATE_PATIENT_ERROR,
  RESET_PATIENT_LIST,
} from './type';

//Load list patient
export const loadPatientListAction = createAction(LOAD_PATIENT_LIST);
export const loadPatientListSuccessAction = createAction(
  LOAD_PATIENT_LIST_SUCCESS,
);
export const loadPatientListErrorAction = createAction(LOAD_PATIENT_LIST_ERROR);

//load list patient in case have role manage independent only( not have role Organisation Candidate/Patient Management)
export const loadCurrentListPatientAction = createAction(
  LOAD_CURRENT_MANAGE_PATIENT_LIST,
);
export const loadCurrentListPatientSuccessAction = createAction(
  LOAD_CURRENT_MANAGE_PATIENT_LIST_SUCCESS,
);
export const loadCurrentListPatientErrorAction = createAction(
  LOAD_CURRENT_MANAGE_PATIENT_LIST_ERROR,
);

//Load patient detail
export const loadPatientDetailAction = createAction(LOAD_PATIENT_DETAIL);
export const loadPatientDetailSuccessAction = createAction(
  LOAD_PATIENT_DETAIL_SUCCESS,
);
export const loadPatientDetailErrorAction = createAction(
  LOAD_PATIENT_DETAIL_ERROR,
);

//Create patient
export const createPatientAction = createAction(CREATE_PATIENT);
export const createPatientSuccessAction = createAction(CREATE_PATIENT_SUCCESS);
export const createPatientErrorAction = createAction(CREATE_PATIENT_ERROR);

//Update patient
export const updatePatientAction = createAction(UPDATE_PATIENT);
export const updatePatientSuccessAction = createAction(UPDATE_PATIENT_SUCCESS);
export const updatePatientErrorAction = createAction(UPDATE_PATIENT_ERROR);

//Reset patient list
export const resetPatientListAction = createAction(RESET_PATIENT_LIST);
